export default "__VITE_ASSET__CJab96yA__"